module.exports = __webpack_public_path__ + "img/prodotto.9378825c.png";